module.exports = __webpack_public_path__ + "static/img/activity_sdy_07-2.c25930a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_07-2.jpg
// module id = cZg1
// module chunks = 0